import type React from 'react';

import { Alert, Link, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useEmailVerificationModalBody } from './hooks/useEmailVerificationModalBody';

type Props = {
	path: string;
	onContinueAsGuest?: () => void;
	userId: string;
};

export const EmailVerificationModalBody: React.FC<Props> = ({ path, onContinueAsGuest, userId }) => {
	const {
		data: { resendEmailResult },
		actions: { resendVerificationEmail },
	} = useEmailVerificationModalBody(path, userId);

	return (
		<>
			{resendEmailResult === 'success' && (
				<Alert variant="success" className="mb-16">
					<Translate value="fe.pages.sponsors.verify_email.verify_email_resent" />
				</Alert>
			)}
			{resendEmailResult === 'error' && (
				<Alert variant="error" className="mb-16">
					<Translate value="fe.errors.sponsors.send_verify_email" />
				</Alert>
			)}
			<Text as="h1" variant="heading" size="medium" fontWeight="bold" className="text-typography-strong text-center">
				<Translate value="fe.pages.sponsors.verify_email.verify_email" />
			</Text>
			<Text as="div" className="text-typography-strong mt-4 text-center">
				<Translate value="fe.pages.sponsors.verify_email.require_verify" />
			</Text>
			<div className="bg-fill-weaker mt-6 mb-4 rounded-lg p-2.5">
				<Text as="div" className="text-typography-strong text-center">
					<Translate value="fe.pages.sponsors.verify_email.check_verify" />{' '}
				</Text>
				<div className="w-full py-3 text-center">
					<Link as="button" bold onClick={resendVerificationEmail} variant="secondary">
						<Translate value="fe.pages.sponsors.verify_email.resend_email" />
					</Link>
				</div>
			</div>
			{onContinueAsGuest && (
				<div className="mt-10 mb-6 text-center">
					<Link as="button" onClick={onContinueAsGuest}>
						<Translate value="fe.pages.sponsors.guest_login" />
					</Link>
				</div>
			)}
		</>
	);
};
